import React, { useContext, useEffect} from "react";
import { Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import {
  getNotificationDetailsById,
  getWebsiteNotificationDetailsById,
} from "../../../services/adminApiService/communicateApi/communicateApi";
import DistrictFilter from "../districtFilter/DistrictFilter";
import { LocationContext } from "../../../context/LocationContext";
import SportFilter from "../sportFilter/SportFilter";
import { useSport } from "../../../context/SportContext";

function PreviewEventModal({
  showPreviewCommunicationModal,
  PreviewModalClose,
  id,
  notificationFor,
  source,
}) {
  console.log({showPreviewCommunicationModal,PreviewModalClose,id,notificationFor});
   const { selectedSportId, setSelectedSportId } = useSport();
  const [data, setData] = React.useState({});


  const { setSelectedDistrictId } = useContext(LocationContext);
  
   console.log("")
  // fetch the data initially
  React.useEffect(() => {
    (async () => {
      setData({}); // Clear previous data
      try {
        let res = null;
        const normalizedNotificationFor = notificationFor
          ?.toLowerCase()
          .replace(/-/g, " ")
          .replace(/\s+/g, " ")
          .trim();

        if (id) {
          if (normalizedNotificationFor === "website") {
            res = await getWebsiteNotificationDetailsById(id);
          } else if (normalizedNotificationFor === "users") {
            res = await getNotificationDetailsById(id);
          } else if (normalizedNotificationFor === "both users & website") {
            if (source === "website") {
              res = await getWebsiteNotificationDetailsById(id);
            } else {
              res = await getNotificationDetailsById(id);
            }
          } else {
            // Fallback or default behavior if needed
             res = await getNotificationDetailsById(id);
          }
        }

        setData(res?.data?.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [id, notificationFor, source]);
  // whenever API data changes, set district in context
 useEffect(() => {
  if (data?.district_id) {
    setSelectedDistrictId(data.district_id.toString());
  }
  if (data?.notification_data?.sport_id) {
    setSelectedSportId(data?.notification_data?.sport_id);
  } else {
    console.warn("No sport_id found in API response", data);
  }
}, [data?.district_id, data?.notification_data?.sport_id, setSelectedDistrictId, setSelectedSportId]);

  

  return (
    <Modal show={showPreviewCommunicationModal} onHide={PreviewModalClose}>
      <div className="modal-header">
        <h4 className="modal-title fs-20">Notification Preview</h4>
        <button type="button" className="btn-close" onClick={PreviewModalClose}>
          <span></span>
        </button>
      </div>
      <div className="modal-body">
        <div className="add-contact-box">
          <div className="add-contact-content">
            {/* 1st Row */}
            <div className="row">
              <div
                className={
                  notificationFor === "Website" ? "col-md-12" : "col-md-6"
                }
              >
                <label className="text-black font-w500">
                  Notification For <span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <Form.Control
                    readOnly
                    defaultValue={notificationFor}
                    name="notification_for"
                    className="form-control"
                  />
                </div>
              </div>

              {notificationFor !== "Website" && (
                <div className="form-group mb-3 col-md-6">
                  <label className="text-black font-w500">
                    Main Category <span className="text-danger">*</span>
                  </label>
                  <div className="contact-name">
                    <Form.Control
                      readOnly
                      defaultValue={data?.main_category_name}
                      name="main_category"
                      className="form-control"
                    />
                  </div>
                </div>
              )}
            </div>
            {/* 2nd Row */}
            {notificationFor !== "Website" && (
              <div className="row">
                <div className="form-group mb-3 col-md-6">
                  <label className="text-black font-w500">
                    Category Type <span className="text-danger">*</span>
                  </label>
                  <div className="contact-name">
                    <Form.Control
                      readOnly
                      defaultValue={data?.category_name}
                      name="category_type"
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="form-group mb-3 col-md-6">
                  <label className="text-black font-w500">
                    Sub Category <span className="text-danger">*</span>
                  </label>
                  <div className="contact-name">
                    <Form.Control
                      readOnly
                      defaultValue={data?.sub_category_name}
                      name="sub_category_name"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="row">
               <div className="form-group mb-3 col-md-6">
                {["users", "both users & website"].includes(
                  notificationFor
                    ?.toLowerCase()
                    .replace(/-/g, " ")      // replace hyphens with spaces
                    .replace(/\s+/g, " ")    // collapse multiple spaces
                    .trim()                  // remove leading/trailing spaces
                ) && (
                    <div className="mt-3 mb-4">
                      <label className="text-black font-w500">
                        Sport <span className="text-danger">*</span>
                      </label>
                       <SportFilter className="district_drop_dwn"
                           disabled={true}
                          />
                    </div>
                  )}

              </div>
              <div className="form-group mb-3 col-md-6">
                {["users", "both users & website"].includes(
                  notificationFor
                    ?.toLowerCase()
                    .replace(/-/g, " ")      // replace hyphens with spaces
                    .replace(/\s+/g, " ")    // collapse multiple spaces
                    .trim()                  // remove leading/trailing spaces
                ) && (
                    <div className="mt-3 mb-4">
                      <label className="text-black font-w500">
                        District <span className="text-danger">*</span>
                      </label>
                      <DistrictFilter className="district_drop_dwn"  disabled={true}/>
                    </div>
                  )}

              </div>


            </div>
            {/* 3rd Row */}
            <div className="row">
              <div className="form-group mb-3 col-md-12">
                <label className="text-black font-w500">
                  Title <span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <Form.Control
                    readOnly
                    required
                    defaultValue={data?.title}
                    name="title"
                    placeholder="Enter Title"
                  />
                </div>
                <span className="validation-text text-danger"></span>
              </div>
            </div>
            {/* 4th row */}
            <div className="row">
              <div className="form-group mb-3 col-md-12">
                <label className="text-black font-w500">
                  Message <span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <Form.Control
                    readOnly
                    defaultValue={data?.message}
                    name="message"
                    as="textarea"
                    placeholder="Message"
                  />
                </div>
              </div>
            </div>
            {/* 5th Row */}
            <div className="row">
              <div className="form-group mb-3 col-md-12">
                <label className="text-black font-w500">URL</label>
                <div className="contact-name">
                  <Form.Control
                    readOnly
                    defaultValue={data?.url}
                    name="url"
                    type="url"
                    placeholder="Enter URL"
                  />
                </div>
              </div>
            </div>
            {/* 6th Row */}
            {/* <div className="row">
              <div className="form-group mb-3 col-md-12">
                <Form.Group controlId="formFile">
                  <Form.Label className="text-black font-w500">
                    Upload Document
                  </Form.Label>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type="file"
                      accept="image/*,application/pdf"
                    />
                  </div>
                </Form.Group>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="modal-footer d-flex justify-content-between">
        <div className="d-flex justify-content-end w-100">
          <button
            type="button"
            className="btn btn-secondary mx-2"
            onClick={PreviewModalClose}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default React.memo(PreviewEventModal);
